import { ArrowCollapseIcon } from './ArrowCollapseIcon';

/**
 * author: Austin Andrews
 * id 86BB43B4-910B-4174-8455-661875054171
 * name arrow-collapse
 * version: 1.6.50
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/arrow-collapse.svg
 * tags
 * - Arrow 
 */
export const ArrowCompressIcon = ArrowCollapseIcon;
export default ArrowCompressIcon